import { ModuleManifest } from "shared/bootstrap";
import store from "./store";
import publicLocale from "./i18n/public.json";
import adminLocale from "./i18n/admin.json";
import { VuePlugins } from "shared/bootstrap/types";

const manifest: ModuleManifest = {
  storeModules: {
    contact: store,
  },
  localisation: { key: "contact", messages: publicLocale },
};

export default manifest;

export const AdminManifest: ModuleManifest = {
  menuItems: [
    {
      to: { name: "messages" },
      title: "contact.menuItems.messages",
      icon: "envelope",
    },
  ],
  routes: [
    {
      path: "/messages",
      name: "messages",
      meta: {
        title: "contact.menuItems.messages",
      },
      // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
      component: () => import("./pages/MessagesOverview.vue"),
    },
  ],
  vuePlugins: [VuePlugins.CompendaIntegration],
  localisation: { key: "contact", messages: adminLocale },
};
